module.exports = __webpack_public_path__ + "static/media/JAR.e3674d19.svg";